import { createContext, useContext, useMemo } from "react";

type TTSContextType = {
	voiceId: string;
	org: string;
	tenantId: string;
	appId: string;
	appName: string;
};

export const TTSContext = createContext<TTSContextType>({
	voiceId: "",
	org: "",
	tenantId: "",
	appId: "",
	appName: "",
});

export const useTTSContext = () => {
	const context = useContext(TTSContext);
	if (!context) {
		throw new Error("useTTSContext must be used within a TTSProvider");
	}
	return context;
};

export const TTSProvider = ({
	children,
	appId,
	appName,
	org,
	tenantId,
	voiceId,
}: {
	children: React.ReactNode;
} & TTSContextType) => {
	const value = useMemo(
		() => ({
			appId,
			appName,
			org,
			tenantId,
			voiceId,
		}),
		[appId, appName, org, tenantId, voiceId],
	);

	return <TTSContext.Provider value={value}>{children}</TTSContext.Provider>;
};
